import React, { forwardRef } from 'react';
import Select from 'react-select';

const Typeahead = forwardRef((props, ref) => {
  return (
    <Select
      ref={ref}
      id={props.id}
      options={props.options}
      onChange={(selectedOption) => props.onChange(selectedOption)}
      onInputChange={(inputValue) => props.onInputChange?.(inputValue)}
      value={props.value}
      placeholder={props.placeholder || 'Select...'}
      isDisabled={props.disabled}
      className="col-sm-12"
      isClearable={props.isClearable || false}
      formatOptionLabel={(option) => option.displayLabel || option.label} // Display JSX
      filterOption={undefined}
      styles={{
        control: (baseStyles, state) => ({
          ...baseStyles,
          height: 45,
        }),
        menu: (baseStyles) => ({
          ...baseStyles,
          zIndex: 1000,
        }),
      }}
      theme={(theme) => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary25: 'rgba(95, 15, 64,.2)',
          primary: 'rgba(95, 15, 64,.6)',
          primary50: 'rgba(95, 15, 64,.2)'
        },
      })}
    />
  );
});

export default Typeahead;